import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';

export function useInterviews() {
  const [interviews, setInterviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'roportajlar'), orderBy('createdAt', 'desc'));
    const unsub = onSnapshot(
      q,
      snap => {
        const data = snap.docs.map(doc => {
          const d = doc.data();
          return {
            id: doc.id,
            title: d.title || '',
            guest: d.guest || '',
            interviewer: d.interviewer || '',
            summary: d.summary || '',
            videoUrl: d.videoUrl || '',
            createdAt: d.createdAt?.toDate?.() ?? new Date(0),
          };
        });
        setInterviews(data);
        setLoading(false);
      },
      err => {
        console.warn('Firestore roportajlar error:', err);
        setLoading(false);
      }
    );
    return () => unsub();
  }, []);

  return { interviews, loading };
}

/* YouTube / Vimeo embed dönüştürücü */
export function toEmbedUrl(url) {
  if (!url) return null;
  try {
    const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/);
    if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
    const shorts = url.match(/youtube\.com\/shorts\/([^?&/]+)/);
    if (shorts) return `https://www.youtube.com/embed/${shorts[1]}`;
    const vim = url.match(/vimeo\.com\/(\d+)/);
    if (vim) return `https://player.vimeo.com/video/${vim[1]}`;
    return url;
  } catch {
    return url;
  }
}

/* YouTube thumbnail */
export function getYoutubeThumbnail(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/);
  if (yt) return `https://img.youtube.com/vi/${yt[1]}/hqdefault.jpg`;
  const shorts = url.match(/youtube\.com\/shorts\/([^?&/]+)/);
  if (shorts) return `https://img.youtube.com/vi/${shorts[1]}/hqdefault.jpg`;
  return null;
}